export const faqItems = [
  {
    question: 'How do artists join Kala Manch?',
    answer: 'Artists can join from the website or Android app using email and password. After sign-up, complete your profile with name, city, art category, bio, profile image, and portfolio links such as YouTube, Instagram, or Spotify.',
  },
  {
    question: 'When does an artist profile become public?',
    answer: 'Artist profiles are reviewed by the admin team. A profile should become visible publicly only after admin verification, so visitors see cleaner and more trusted listings.',
  },
  {
    question: 'Is mobile number mandatory for artists or collaborators on app or website?',
    answer: 'No. Mobile number is optional profile contact information. Email and password are the main account login method for both website and app.',
  },
  {
    question: 'Why are contact details hidden until login?',
    answer: 'Kala Manch hides email, phone, and social/contact details from public cards to reduce scraping, spam, and misuse. Logged-in artists and collaborators can view profile contact details where allowed.',
  },
  {
    question: 'How can collaborators contact artists?',
    answer: 'Collaborators can create an account, sign in, view artist profiles, send enquiries, and continue conversations through the Private Message Board.',
  },
  {
    question: 'Can artists message collaborators?',
    answer: 'Yes. Logged-in artists can view collaborator profiles and send messages or enquiries through the Private Message Board when a relevant opportunity is available.',
  },
  {
    question: 'How does PMB work between website and Android app?',
    answer: 'PMB is shared across website and Android app. New messages can appear in either platform after refresh. Use PMB inbox actions such as read, unread, and delete where available for your account role.',
  },
  {
    question: 'How do push notifications work in the app?',
    answer: 'Android app users receive push notifications for supported updates such as PMB messages and admin alerts when notifications are enabled. Users can manage push notification preference inside their account settings in the app.',
  },
  {
    question: 'How are images and videos managed?',
    answer: 'Artists can upload profile images and add approved portfolio links or YouTube performance videos. Admin can review media and remove unsafe, adult, misleading, or low-quality content.',
  },
  {
    question: 'How can I reset password?',
    answer: 'Use the Forgot Password option on website or app login screen. Reset instructions are sent to your registered email address.',
  },
  {
    question: 'How can I request account deletion?',
    answer: 'Follow the account deletion process at /account-deletion or email me@kalamanch.art from your registered email with your role and account details.',
  },
  {
    question: 'What should I do if I see unsafe content?',
    answer: 'Use the Trust & Safety page or Contact page to report profiles, images, videos, or messages that look unsafe, misleading, copied, abusive, or inappropriate.',
  },
];

export const faqPreviewItems = faqItems.slice(0, 4);
